import ServiceBase from "base/baseService"

export default class CondicaoProdutoService extends ServiceBase {

    title = "Condição de produto"
    pluralTitle = "Condição de produtos"
    url = '/cadastro/produto/condicaoproduto'
    frontUrl = '/cadastro/produto/condicaoproduto'
    frontUrlList = '/cadastro/produto/condicaoprodutolist'
    primaryKey = 'codigo_conp'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        return data
    }

    prepareToSave({ data }) {

        delete data.meta

        return data

    }

}
